/**
 * Pokexclusive Global JS
 * Scroll reveal + slab tilt + live bar toggle
 */

(function () {
  'use strict';

  // ── Toast + cart-icon pulse ────────────────────────────────
  (function injectToastStyles() {
    var style = document.createElement('style');
    style.textContent = [
      '.pkx-toast{',
        'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(12px);',
        'background:#1A1830;border:1px solid rgba(155,93,229,0.45);',
        'color:#E0AAFF;font-size:14px;font-weight:600;letter-spacing:.03em;',
        'padding:11px 22px;border-radius:8px;white-space:nowrap;',
        'box-shadow:0 4px 24px rgba(155,93,229,0.25);',
        'opacity:0;transition:opacity .22s ease,transform .22s ease;',
        'pointer-events:none;z-index:10000;',
      '}',
      '.pkx-toast.is-visible{opacity:1;transform:translateX(-50%) translateY(0);}',
      '@keyframes pkx-cart-bump{',
        '0%{transform:scale(1)}',
        '35%{transform:scale(1.28)}',
        '65%{transform:scale(0.92)}',
        '100%{transform:scale(1)}',
      '}',
      '.pkx-cart-bump{animation:pkx-cart-bump .42s cubic-bezier(.4,0,.2,1) forwards;}',
    ].join('');
    document.head.appendChild(style);
  })();

  var toastTimer = null;

  function showToast(msg) {
    msg = msg || '✓ Tillagd i varukorgen';
    var el = document.getElementById('PkxToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'PkxToast';
      el.className = 'pkx-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    clearTimeout(toastTimer);
    // Force reflow so re-trigger animation works
    el.classList.remove('is-visible');
    void el.offsetWidth;
    el.classList.add('is-visible');
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2600);
  }

  function pulseCartIcon() {
    var icon = document.getElementById('CartToggle');
    if (!icon) return;
    icon.classList.remove('pkx-cart-bump');
    void icon.offsetWidth;
    icon.classList.add('pkx-cart-bump');
    icon.addEventListener('animationend', function handler() {
      icon.classList.remove('pkx-cart-bump');
      icon.removeEventListener('animationend', handler);
    });
  }

  window.PokexclusiveToast = { show: showToast };

  // ── Scroll Reveal ──────────────────────────────────────────
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          // Stagger by index for sibling groups
          const delay = entry.target.dataset.revealDelay || i * 80;
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, delay);
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  document.querySelectorAll('.reveal').forEach((el) => revealObserver.observe(el));

  // ── Slab Tilt (desktop only) ───────────────────────────────
  if (window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('[data-tilt]').forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = `perspective(800px) rotateY(${x * 10}deg) rotateX(${-y * 10}deg) translateY(-4px)`;
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
      });
    });
  }

  // ── Cart count sync ───────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  document.addEventListener('cart:updated', updateCartCount);

  // ── Hero CTA: scroll to next visible section block ───────────
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-scroll-next-section]');
    if (!link) return;
    e.preventDefault();

    // Shopify wraps every section in .shopify-section — walk up to that wrapper
    const heroWrapper = link.closest('.shopify-section');
    if (!heroWrapper) return;

    // Find next sibling that has visible height (skips disabled/empty blocks)
    let next = heroWrapper.nextElementSibling;
    while (next && next.getBoundingClientRect().height === 0) {
      next = next.nextElementSibling;
    }
    if (!next) return;

    const header = document.querySelector('.site-header');
    const offset = header ? header.getBoundingClientRect().height : 0;
    const top = next.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  // ── Quick Add ─────────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    const variantId = btn.dataset.quickAdd;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Lägger till...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((r) => {
        // Check status before parsing body — non-ok responses (e.g. 422 out-of-stock)
        // have valid JSON but should not be treated as success
        if (!r.ok) throw new Error('add_failed_' + r.status);
        return r.json();
      })
      .then(() => {
        btn.textContent = 'Tillagd!';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        showToast();
        pulseCartIcon();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      })
      .catch(() => {
        // Silently revert — no alarming error text for expected cases like out-of-stock
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });
})();
